import { freeBetStore } from '@pascal/pascal-core';
import { loadingStore, popupStore } from '@pascal/pascal-core/shared/core/store';
import { PopUps } from '@pascal/pascal-core/table-line/t_types/enums/PopupTypes';
import { liveConnection } from '../core';

export const visibilityChangeHandler = async () => {
  if (popupStore.popupName !== PopUps.ConnectionError) {
    loadingStore.updateIsAdditionalLoading(true);
    freeBetStore.resetActiveFreeBet();
    await liveConnection.connectionInitCallback(false);
  }
};
